import React from 'react';

import ProgramPlanComponent from './program-plan.component';
import AssistanceProgramBasicInfoComponent from './assistance-programs-basic-info.component';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

export const AssistanceProgramComponent = ({ handleDelete, vehicleTypes, selectedAssistancePlans, selectedAssistancePrograms, termsLibraries, handleFormPlanIItemChange, fileTypes, mediaFiles, handleFormMediaItemChange, changeImage, onInnerBasicFormChange, back, handleFormSubmit }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <AssistanceProgramBasicInfoComponent
                    termsLibraries={termsLibraries}
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedAssistancePrograms={selectedAssistancePrograms}
                />
            ),
            isVisible: true,
        },
        {
            id: 2,
            title: 'Program Plans',
            component:
                <ProgramPlanComponent
                    handleDelete={handleDelete}
                    selectedAssistancePlans={selectedAssistancePlans}
                    onFormPlanItemChange={handleFormPlanIItemChange}
                    vehicleTypes={vehicleTypes}

                />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Media',
            component:
                <MediaInfoComponent
                    changeImage={changeImage}
                    // deleteSelectedProduct={deleteSelectedCategory}
                    fileTypes={fileTypes}
                    //handleClose={handleClose}
                    //handleOpen={handleOpen}
                    onFormItemChange={handleFormMediaItemChange}
                    // openConfirmation={openConfirmation}
                    mediaFiles={mediaFiles}
                //uploadToDigiiFolder={uploadToDigiiFolder}
                />,
            isVisible: true,
        },

    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default AssistanceProgramComponent;
